module.exports = __webpack_public_path__ + "assets/7c461b2696f56836d21111621265954d.png";